import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "./api";
import { suivreNotificationsNonLues } from "./sonAlerte";

// Pastilles rouges : messages non lus, demandes d'assistance, documents reçus
// non ouverts et, pour l'élève, chaque contenu nouveau tant qu'il n'est pas ouvert.
export const EVENEMENT_COMPTEURS = "ql-compteurs";
export const COMPTEURS_VIDES = {
  messages: 0, assistances: 0, boite: 0, notifications: 0,
  lecons: 0, videos: 0, exercices: 0, devoirs: 0, evaluations: 0,
  nouveaux: { lecons: [], videos: [], exercices: [], devoirs: [], evaluations: [] },
};
const INTERVALLE_MS = 30000;

export function rafraichirCompteurs() {
  window.dispatchEvent(new Event(EVENEMENT_COMPTEURS));
}

export function useCompteurs(declencheur) {
  const [compteurs, setCompteurs] = useState(COMPTEURS_VIDES);
  const charger = useCallback(() => {
    api.get("compteurs/").then(r => {
      setCompteurs({ ...COMPTEURS_VIDES, ...r.data });
      suivreNotificationsNonLues(r.data?.notifications);  // son d'alerte à l'arrivée
    }).catch(() => {});
  }, []);
  useEffect(() => { charger(); }, [charger, declencheur]);
  useEffect(() => {
    const minuterie = window.setInterval(charger, INTERVALLE_MS);
    window.addEventListener(EVENEMENT_COMPTEURS, charger);
    window.addEventListener("focus", charger);
    return () => {
      window.clearInterval(minuterie);
      window.removeEventListener(EVENEMENT_COMPTEURS, charger);
      window.removeEventListener("focus", charger);
    };
  }, [charger]);
  return compteurs;
}

export function Pastille({ nombre, className = "" }) {
  if (!nombre) return null;
  return (
    <span className={`ql-pastille ${className}`.trim()} aria-label={`${nombre} non lu${nombre > 1 ? "s" : ""}`}>
      {nombre > 99 ? "99+" : nombre}
    </span>
  );
}

// L'élève a ouvert un contenu : sa pastille disparaît partout.
export function marquerOuvert(type, id) {
  if (!id) return;
  api.post("compteurs/ouvert/", { type, id }).then(rafraichirCompteurs).catch(() => {});
}

// Petit point rouge à côté d'un élément nouveau, pas encore ouvert.
export function PointNouveau({ visible }) {
  if (!visible) return null;
  return <span className="ql-point-nouveau" title="Nouveau : pas encore ouvert" aria-label="Nouveau" />;
}

// Contenus nouveaux de l'élève, partagés par toutes les listes de l'espace élève.
export const NouveautesContext = createContext({});
export function useNouveau(type, id) {
  const nouveaux = useContext(NouveautesContext);
  return !!id && (nouveaux[type] || []).includes(id);
}

// Point rouge d'un contenu de l'élève (utilisable dans une liste).
export function PointNouveauContenu({ type, id }) {
  return <PointNouveau visible={useNouveau(type, id)} />;
}

// Rubrique ouverte : ses notifications sont lues et le point rouge de la cloche
// disparaît, y compris pour une notification qui arrive pendant que l'on y est.
export function useNotificationsDeLaRubrique(sections, nonLues) {
  const cle = (sections || []).join(",");
  useEffect(() => {
    if (!cle || !nonLues) return;
    api.patch("notifications/", { sections: cle.split(",") }).then(rafraichirCompteurs).catch(() => {});
  }, [cle, nonLues]);
}
